import ab from 'mk2/containers/AB/AB.sagas';
import adSlot from 'mk2/containers/AdSlot/AdSlot.sagas';
import adSlotBranding from 'mk2/containers/AdSlotBranding/AdSlotBranding.sagas';
import complaint from 'mk2/containers/Complaint/Complaint.sagas';
import complaints from 'mk2/containers/Complaints/Complaints.sagas';
import like from 'mk2/containers/Like/Like.sagas';
// import newsletterModal from 'mk2/containers/NewsletterModal/NewsletterModal.sagas';
import pageHeader from 'mk2/containers/PageHeader/PageHeader.sagas';
import phoneVerification from 'mk2/containers/PhoneVerification/PhoneVerification.sagas';
import phoneVerificationModal from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.sagas';
import photosUpload from 'mk2/containers/PhotosUpload/PhotosUpload.sagas';
import privacyReminder from 'mk2/containers/PrivacyReminder/PrivacyReminder.sagas';
import star from 'mk2/containers/Star/Star.sagas';
import toolbar from 'mk2/containers/Toolbar/Toolbar.sagas';
import undoToast from 'mk2/containers/UndoToast/UndoToast.sagas';
import analytics from 'mk2/sagas/analytics';
import request from 'mk2/sagas/request';
import { all, fork } from 'redux-saga/effects';

export default function* root() {
    yield all([
        // Global sagas
        fork(request),
        fork(analytics),

        // Global containers
        fork(adSlot),
        fork(ab),
        fork(adSlotBranding),
        fork(complaint),
        fork(complaints),
        fork(star),
        fork(toolbar),
        fork(undoToast),
        fork(like),
        fork(pageHeader),
        fork(phoneVerification),
        fork(phoneVerificationModal),
        fork(photosUpload),
        // fork(newsletterModal),
        fork(privacyReminder),
    ]);
}
